import { useEffect, useState } from 'react';
import { notification } from 'antd';

import { useAppDispatch } from '../../store';
import {
  loadInfoScreenAction,
  updateInfoScreenAction
} from 'store/infoScreens/infoScreens.actions';
import { IInfoScreenData, IEditInfoScreen } from '../../types/infoScreens.types';

const useInfoScreen = (
  id: number,
) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IInfoScreenData>();

  useEffect(() => {
    setLoading(true);
    dispatch(loadInfoScreenAction({ id }))
      .then((data: IInfoScreenData) => {
        setData(data);
      })
      .catch((e: any) => notification.error({ message: e?.message }))
      .finally(() => setLoading(false));
  }, [id]);

  const handleEdit = async (data: IEditInfoScreen) => {
    return dispatch(updateInfoScreenAction({ id, data }))
      .then((data: IInfoScreenData) => {
        setData(data);
      });
  };
  return {
    data,
    loading,
    onEdit: handleEdit,
  };
};

export default useInfoScreen;
